import React from "react";
import { addBankApi, getBankByIdApi, updateBankApi } from "../..//Api/Bank";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchPurposeApi } from "../../Api/DonationPurpose";
import toast from "react-hot-toast";

interface BankDetailsFormProps {
  url: string;
    onClose: () => void;
    onSaved?:() => void;
    editBankId?: string | null; 
}

export const BankDetailsForm = ({ url, onClose, onSaved,editBankId }: BankDetailsFormProps) => {
  const [BankName, setBankName] = useState("");
  const [BankBranch, setBankBranch] = useState("");
  const [IfscCode, setIfscCode] = useState("");
  const [AccNo, setAccNo] = useState("");
  const [Id, setId] = useState("");
  const [isEdit, setIsEditMode] = useState(false);
  const [loading, setLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const [, setBankId] = useState("");
  const [isEzpay, setIsEzpay] = useState("false");

  const navigation = useNavigate();
  const location = useLocation();
  const id = editBankId;


  const [donationpurposes, setdonationpurposes] = useState<any>([])
  const [PurposeId, setPurposeId] = useState<string>("")

  useEffect(() => {
    const handleApiClick = async () => {
      try {
        if (id) {
          const bankData = await getBankByIdApi(url, id);
          const bankToEdit = bankData.find((bank: any) => bank.id === id);
          if (bankToEdit) {
            setId(bankToEdit.id);
            setBankName(bankToEdit.name);
            setBankBranch(bankToEdit.branch);
            setIfscCode(bankToEdit.ifscCode);
            setAccNo(bankToEdit.accountNumber);
            setPurposeId(bankToEdit.donationPurposeId);
            setIsEzpay(bankToEdit.isEzpay ? "true" : "false");
            setIsEditMode(true);
            setLoading(false);
          }
        }
      } catch (error) {
        setHasError(true);
        setLoading(false);
        toast.error("Network error. Please try again later.", {
          id: "networkError",
        });
      }
    };
    handleApiClick();
  }, [id, url]);

  const handleSubmitClick = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!BankName || !BankBranch || !IfscCode || !AccNo) {
      toast.error("Please fill all the fields")
      return;
    }
    const isEzpayBoolean = isEzpay === "true";

    try {
      if (isEdit) {
        await updateBankApi(Id, BankName, BankBranch, IfscCode, AccNo, PurposeId, isEzpayBoolean, url);
        toast.success("Bank updated successfully");
      } else {
        await addBankApi(BankName, BankBranch, IfscCode, AccNo, PurposeId, isEzpayBoolean, url);
        toast.success("Bank Added Successfully");
      }
      if(onSaved) onSaved();
      onClose();
    } catch (error) {
      toast.error(isEdit ? "Failed to update Bank" : "Unable to add Bank");
    }

    setBankName("");
    setBankBranch("");
    setIfscCode("");
    setAccNo("");
    setIsEzpay("false");
  };

  const handleResetForm = () => {
    setBankName("");
    setBankBranch("");
    setIfscCode("");
    setAccNo("");
    setIsEzpay("false");
    onClose();
  };

  useEffect(() => {
    if (id) {
      setBankId(id);
      setIsEditMode(true);
      setLoading(true);
    } else {
      setIsEditMode(false);
      setLoading(false);
    }
  }, [id]);


  useEffect(() => {
    const fetchData = async () => {
      try {

        const response = await fetchPurposeApi(url);
        console.log("response", response)
        setdonationpurposes(response);
      } catch (error) {
        console.error("Error fetching Data:", error);
      }
    };
    fetchData();
  }, [url]);


  return (
    <div className="px-4">
      <div>
        {loading ? (
          <div className="flex justify-center items-center h-screen">
            <div
              className="flex justify-center items-center h-12 w-12 animate-spin rounded-full border-4 border-solid border-current border-e-transparent align-[-0.125em] text-surface motion-reduce:animate-[spin_1.5s_linear_infinite] text-blue-600"
              role="status"
            >
              <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
                Loading...
              </span>
            </div>
          </div>
        ) : hasError ? (
          <div className="flex justify-center items-center h-screen">
            {/* Blank page when there’s a network error */}
          </div>
        ) : (
          <>
            <div className=" text-3xl font-bold text-blue-600 mb-5 mt-5 justify-center">
              {isEdit ? "Update Bank Details" : "Add New Bank Details"}
            </div>
            <form onSubmit={handleSubmitClick} className="mt-8 space-y-4">
              <div className="flex flex-col gap-4">
                <div>
                  <label
                    htmlFor="bankName"
                    className="block text-sm font-medium text-black dark:text-gray-200 mb-2"
                  >
                    Bank Name
                  </label>
                  <input
                    id="bankName"
                    type="text"
                    required
                    placeholder="Bank Name"
                    value={BankName}
                    onChange={(event) => setBankName(event.target.value)}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                <div>
                  <label
                    htmlFor="bankBranch"
                    className="block text-sm font-medium text-black dark:text-gray-200 mb-2"
                  >
                    Branch
                  </label>
                  <input
                    id="bankBranch"
                    type="text"
                    required
                    placeholder="Branch Name"
                    value={BankBranch}
                    onChange={(event) => setBankBranch(event.target.value)}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                <div>
                  <label
                    htmlFor="ifscCode"
                    className="block text-sm font-medium text-black dark:text-gray-200 mb-2"
                  >
                    IFSC Code
                  </label>
                  <input
                    id="ifscCode"
                    type="text"
                    required
                    placeholder="IFSC0000XXX"
                    value={IfscCode}
                    onChange={(event) => setIfscCode(event.target.value)}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                <div>
                  <label
                    htmlFor="accNo"
                    className="block text-sm font-medium text-black dark:text-gray-200 mb-2"
                  >
                    Account Number
                  </label>
                  <input
                    id="accNo"
                    type="number"
                    required
                    placeholder="1234567890"
                    value={AccNo}
                    onChange={(event) => setAccNo(event.target.value)}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-black dark:text-gray-200 mb-2">
                    Purpose :
                  </label>
                  <select
                    id="donationPurpose"
                    required
                    value={PurposeId}
                    onChange={(e) => setPurposeId(e.target.value)}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="">Select Purpose</option>
                    {donationpurposes.map((option: any) => (
                      <option key={option.id} value={option.id}>
                        {option.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-black dark:text-gray-200 mb-2">
                    Is Ezpay :
                  </label>
                  <select
                    id="isEzpay"
                    required
                    value={isEzpay}
                    onChange={(e) => setIsEzpay(e.target.value)}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="false">No</option>
                    <option value="true">Yes</option>
                  </select>
                </div>


                <div className="flex justify-start space-x-4">
                  <button
                    type="submit"
                    className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    {isEdit ? "Update" : "Save and Close"}
                  </button>
                  <button
                    type="button"
                    onClick={handleResetForm}
                    className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-gray-300"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
};
